// Characters a generated PDF's file name may not contain.
const forbiddenCharsRegex = /[<>?"*|/]/g;

/**
 * Turns forbidden characters into spaces, so a pasted form title such as
 * "Wound Care / Skin Assessment" is still a valid file name.
 * @param {string} value
 * @return {string}
 */
export function sanitizePDFName(value) {
  return value.replace(forbiddenCharsRegex, ' ').replace(/ {2,}/g, ' ');
}
